<style>
    .notification-list-item:hover{
        cursor: pointer;
    }
</style>
<header class="app-header navbar">
    <button class="navbar-toggler d-lg-none" type="button" appMobileSidebarToggler *ngIf="authService.loggedIn">
    <span class="navbar-toggler-icon"></span>
  </button>
    <a class="navbar-brand" href="#"><b>Roaming SE</b></a>
    <button class="navbar-toggler d-md-down-none mr-auto" type="button" appSidebarToggler *ngIf="authService.loggedIn">
    <span class="navbar-toggler-icon"></span>
 </button>
    <!-- <button class="navbar-toggler d-md-down-none" type="button" appAsideMenuToggler *ngIf="authService.loggedIn">
    <span class="navbar-toggler-icon"></span>
  </button> -->
    <ul class="nav navbar-nav ml-auto" *ngIf="authService.loggedIn">
        <li class="nav-item dropdown" dropdown placement="bottom right">
                        <a class="nav-link roamingse-hand" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="getAllNotifications();"><i class="icon-bell"></i><span class="badge badge-pill badge-danger">{{count}}</span></a>
                        <div class="dropdown-menu dropdown-menu-right" (scroll)="onScroll($event)" *dropdownMenu aria-labelledby="simple-dropdown" style="overflow: auto;height: 450px;width:700px;">
                            <div class="dropdown-header text-center row" style="    margin-left: 0;margin-right: 0;"><strong>Notifications</strong>  <img *ngIf="isSuperAdmin" class="export-notification" title="Export Notification"  src="../../../assets/img/icon-excel-export.png" (click)="getAllNotifications($event,true)"/></div>
                            <a class="dropdown-item notification-list-item" *ngFor="let notification of notifications" (click)="openNotificationDetatil($event,notification)">
                                <div class="notification-item">
                                    <!-- <h6 class="item-title">Evaluation Deadline 1 </h6> -->
                                    <p class="item-info" *ngIf="!notification.read" style="word-break: break-all;width: 100%;
                                    white-space: normal;"><b>{{notification.description}}</b></p>
                                    <p class="item-info" *ngIf="notification.read" style="word-break: break-all;width: 100%;
 white-space: normal;">{{notification.description}}</p>
                                    <span style="color:darkgrey; font-size:12px;"><i class="icon-clock small"></i>
                                        {{notification.created_at |dateTimeFormat}}
                                    </span>
                                </div>
                            </a>
                            <ngx-loading [show]="loadingNotificattion" [config]="{ backdropBorderRadius: '0px' }"></ngx-loading>
                        </div>
                    </li>
        <li class="nav-item dropdown" dropdown placement="bottom right">
            <a class="nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
                <img *ngIf="!(photo_url == undefined || photo_url == null)" src="{{appConfig.s3DocumentUrl}}{{photo_url}}" class="img-avatar" alt="" style="width:35px;"/>
                <i  *ngIf="(photo_url == undefined || photo_url == null)" class="fa fa-user-circle-o icon-size-large" aria-hidden="true"></i></a>
            <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
                <div class="dropdown-header text-center"><strong>Settings</strong></div>
                <a class="dropdown-item" href="#" [routerLink]="['/profile']"><i class="fa fa-user"></i> Profile</a>
                <a class="dropdown-item" (click)="logout()"><i class="fa fa-lock"></i> Logout</a>
            </div>
        </li>
        <li>{{authService.user.first_name}} {{authService.user.last_name}}</li>
        <button class="navbar-toggler d-md-down-none" type="button" appAsideMenuToggler>
        <span class="navbar-toggler-icon"></span>
      </button>
    </ul>
</header>


// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/components/app-header/app-header.component.html